export default __webpack_public_path__ + "static/media/third-right-img-2x.4aa2fa11.png";